import { Box } from "@mui/material";
import React from "react";
import { slidingBg, slidingText } from "../styles/mainStyles";

/** Sliding Puzzle Quest — full-viewport shell for `/mobile/sliding/*` (no site header). */
export default function Layout({ children }) {
    return (
        <Box
            sx={{
                minHeight: "100dvh",
                width: "100%",
                boxSizing: "border-box",
                bgcolor: slidingBg,
                color: slidingText,
                overflowX: "hidden",
            }}
        >
            {children}
        </Box>
    );
}
